export class mdlDriverInfoRes {
    public EnglishFullName: string;
    public ArabicFullName: string;
    public DateOfBirth: string;
    public NationalityCode: string;
    public Gender: string;
    public IDCityCode: string;
    public DriverAge: string;
    public DriverMaritalStatus : string;
   public DriverMaritalStatusExists :boolean;
    public Status: YakeenStatusMdl=new YakeenStatusMdl();
}



export class YakeenStatusMdl
{
    public  StatusCode: string;
    public  StatusDecEn: string;
    public StatusDescAr: string;
    public Result: string;
    public msgKey: string;
    
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlDriverInfoRes.ts